// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oexgjmhrklbbkdfzzqjq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9leGdqbWhya2xiYmtkZnp6cWpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcxNDk4MjIsImV4cCI6MjA3MjcyNTgyMn0.9OC81kLf_DL3Aeo0Zt0KXZXqUg-dDoqFBBoKcxIXMWM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});